import { Menu, MenuItem } from "@mui/material";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { ReactNode, useState } from "react";
import { TinyButton } from "./TinyButton";

const menuSlotProps = {
    paper: { sx: { "& .MuiMenuItem-root": { fontSize: 13, minHeight: 30 } } },
};

// Dropdown is the compact select list used everywhere. It renders as text
// rather than a form field, so it can sit inline in a sentence or a toolbar.
export function Dropdown<T extends string | number>(props: {
    value: T;
    options: { value: T; label: string }[];
    onChange: (value: T) => void;
    startIcon?: ReactNode;
    width?: number;
    disabled?: boolean;
    open?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
}) {
    // the menu anchors to the trigger, which needs to be a node rather than a
    // ref so an externally-opened menu has somewhere to attach on first render
    const [trigger, setTrigger] = useState<HTMLElement | null>(null);
    const [selfOpen, setSelfOpen] = useState(false);

    const open = props.open === undefined ? selfOpen : props.open;

    const setOpen = (value: boolean) => {
        setSelfOpen(value);
        if (value) props.onOpen?.();
        else props.onClose?.();
    };

    const selected = props.options.find(option => option.value === props.value);

    return (
        <>
            <TinyButton
                ref={setTrigger}
                width={props.width}
                disabled={props.disabled}
                aria-haspopup="listbox"
                aria-expanded={open}
                onClick={() => setOpen(true)}
                startIcon={props.startIcon}
                endIcon={<ArrowDropDown sx={{ fontSize: 18, color: "action.active" }} />}
            >
                {selected?.label}
            </TinyButton>

            <Menu
                anchorEl={trigger}
                open={open}
                onClose={() => setOpen(false)}
                slotProps={menuSlotProps}
            >
                {props.options.map(option => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === props.value}
                        onClick={() => {
                            props.onChange(option.value);
                            setOpen(false);
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
